import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9141 16.2139L16.6279 23.5H12.501L12.5 19.3721L19.7861 12.0859L23.9141 16.2139ZM14.5 20.2002L14.501 21.5H15.7988L18.749 18.5488L17.4502 17.25L14.5 20.2002ZM18.8643 15.8359L20.1631 17.1348L21.085 16.2129L19.7861 14.9141L18.8643 15.8359Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V10.4707L19.7861 9.25781L10.5 18.5439L10.501 23H3V1H15.4141L21 6.58594ZM14.5 7.5H19V7.41016L14.5898 3H14.5V7.5Z"}}]};

const FileEditFilled = Vue.extend<IconProps>({
  name: 'FileEditFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-edit-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileEditFilled;
